import api from './api';

export interface RamoProv {
  codigoramoprov?: string;
  nombreramoprov?: string;
  ctactasxpg?: number;
  ctacompras?: number;
  estadoramoprov?: string;
}

export interface RamosProvSearchParams {
  searchTerm?: string;
  pageNumber: number;
  pageSize: number;
  codigoramoprov?: string;
  nombreramoprov?: string;
  estadoramoprov?: string;
}

export interface RamosProvPagedResult {
  items: RamoProv[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

const ramoProvService = {
  getRamosProv: async (params?: RamosProvSearchParams): Promise<RamoProv[]> => {
    const resp = await api.get('/api/RamosProv', params ? { params } : {});
    const data = resp.data;
    if (Array.isArray(data)) return data as RamoProv[];
    if (data && 'items' in data) return data.items as RamoProv[];
    return [];
  },

  getRamosProvPaged: async (params: RamosProvSearchParams): Promise<RamosProvPagedResult> => {
    const resp = await api.get('/api/RamosProv', { params });
    const data = resp.data;
    if (Array.isArray(data)) {
      return {
        items: data as RamoProv[],
        totalCount: data.length,
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        totalPages: Math.ceil(data.length / params.pageSize) || 1
      };
    }
    if (data && typeof data === 'object' && 'items' in data) {
      return data as RamosProvPagedResult;
    }
    return {
      items: [],
      totalCount: 0,
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      totalPages: 0
    };
  },
  
  getRamoProv: async (codigoramoprov: string): Promise<RamoProv> => {
    const resp = await api.get(`/api/RamosProv/${codigoramoprov}`);
    return resp.data as RamoProv;
  },

  createRamoProv: async (ramoProv: RamoProv): Promise<RamoProv> => {
    const response = await api.post<RamoProv>('/api/RamosProv', ramoProv);
    return response.data;
  },

  updateRamoProv: async (codigoramoprov: string, ramoProv: RamoProv): Promise<void> => {
    await api.put(`/api/RamosProv/${codigoramoprov}`, ramoProv);
  },

  deleteRamoProv: async (codigoramoprov: string): Promise<void> => {
    await api.delete(`/api/RamosProv/${codigoramoprov}`);
  }
};

export default ramoProvService;

